module.exports = __webpack_public_path__ + "img/atm2.6b0d7161.svg";